import { FC, useRef, useState } from "react";
import { DownOutlined, EditOutlined } from "@ant-design/icons";
import { DocumentCard } from "../../../design-system/components/DocumentList/DocumentCard";
import { ProjectDocument } from "../../../types/ProjectTypes";
import { useClickOutside } from "../../../common/useClickOutside";
import styles from "./DocumentWidget.module.less";

interface DocumentWidgetProps {
    documents: ProjectDocument[];
    canEdit?: boolean;
    onAction?: () => void;
}

export const DocumentWidget: FC<DocumentWidgetProps> = ({
    documents,
    canEdit,
    onAction,
}) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useClickOutside(dropdownRef, open, () => setOpen(false));

    const activeDocuments = documents.filter((d) => !d.isDeleted);

    return (
        <div className={styles.wrapper} ref={dropdownRef}>
            <button
                className={styles.trigger}
                onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
            >
                <span>{activeDocuments.length}</span>
                <DownOutlined className={styles.chevron} />
            </button>

            {open && (
                <div className={styles.dropdown}>
                    <div className={styles.dropdownTitle}>Documents</div>
                    <div className={styles.divider} />
                    <div className={styles.documentList}>
                        {activeDocuments.length === 0 ? (
                            <div className={styles.emptyMessage}>No documents</div>
                        ) : (
                            activeDocuments.map((pd) => (
                                <div key={pd.id} className={styles.documentItem}>
                                    <DocumentCard
                                        name={pd.document.name}
                                        uploadedBy={pd.creator?.name}
                                        uploadedAt={pd.recordCreationDate}
                                    />
                                </div>
                            ))
                        )}
                    </div>
                    {canEdit && onAction && (
                        <>
                            <div className={styles.divider} />
                            <button
                                className={styles.actionItem}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onAction();
                                    setOpen(false);
                                }}
                            >
                                <EditOutlined className={styles.actionIcon} />
                                Add / remove documents
                            </button>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};
